<script setup lang="ts">
import AppNavLink from "./AppNavLink.vue";
import IconArrowUpRight from "../components/icons/ArrowUpRight.vue";
import { useRouter } from "vue-router";
import { computed } from "vue";
import { useMenuStore } from "@/stores/menu.ts";

const menuStore = useMenuStore();
const router = useRouter();
const isAccount = computed(() => {
  return router.currentRoute.value.path.includes("/account");
});
</script>

<template>
  <app-nav-link
    v-if="isAccount"
    tag="router-link"
    to="/"
    class="hidden md:flex items-center"
  >
    Back to Simply Broadband
    <icon-arrow-up-right class="ml-2 h-4" />
  </app-nav-link>
  <ul
    v-else
    class="flex xl:gap-x-10 gap-x-5 font-bold text-xl text-primary-text"
  >
    <li v-for="item of menuStore.header" :key="item.title">
      <app-nav-link v-bind="item" class="hover:text-green">
        {{ item.title }}
      </app-nav-link>
    </li>
  </ul>
</template>
